import { CurrencyData, NetworkCurrencyDTO } from "modules/PromoItems/services/promoItems.service";
import { IdNamePair } from "service/generic.types";
import { PromoCategoryType } from "./staticData.types";
import {
  createQueryService,
} from "utils/factories";

export default class StaticDataService {
  static readonly fetchCategoryTree = createQueryService<any[]>(
    "/api/PslSpendCat/GetPslSpendCat"
  );

  static readonly fetchBusinessUnits = createQueryService<IdNamePair[]>(
    "/api/HackathonPsl/GetPslBusinessUnits"
  );

  static readonly fetchStaticCurrencies: () => CurrencyData[] = () => {

    return [
      { value: "USD", label: "USD" },
      { value: "EUR", label: "EUR" },
      { value: "CHF", label: "CHF" },
    ].map((c) => new CurrencyData("", c.value, c.label, false));
  }

  static readonly fetchPromoCategoryTypes: () => PromoCategoryType[] = () => {
    return [
      { id: 0, code: "A", name: "Type A", description: "Food Contact Materials" },
      { id: 1, code: "B", name: "Type B", description: "Toys" },
      { id: 2, code: "C", name: "Type C", description: "All other item" },
      { id: 3, code: "D", name: "Type D", description: "Textiles" },
      { id: 4, code: "E", name: "Type E", description: "Electric and Electronic Item" },
    ];
  }

  static readonly fetchAllCurrencies = createQueryService<NetworkCurrencyDTO[]>(
    "/api/HackathonPsl/GetAllCurrencies"
  );

  static readonly fetchLanguages = createQueryService<
    any,
    { searchTerm: string }
  >(`/api/HackathonPsl/GetLanguages`);
}
